import React from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types'
import Image from "../Image";

const GridItem = (props) => {
  const {url, image, title} = props;
  return (
    <div>
      <Link to={url} className="blog-1">
        <Image className="img-fluid img-100 blog-1-img transition" image={image} />
        <div className="blog-1-content">
          <h5>{title}</h5>
          <h6>
            View Project
            <Image image={"images/arrow.svg"} />
          </h6>
        </div>
      </Link>
    </div>
  );
};

GridItem.propTypes = {
  url : PropTypes.string.isRequired,
  image : PropTypes.string.isRequired,
  title : PropTypes.string.isRequired
}

export default GridItem;
